import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

import { NgxPaginationModule } from 'ngx-pagination';
import { MyDatePickerModule } from 'mydatepicker';

import { WmPaginationComponent } from './pagination.component';

import { WmDecimalPercentDirective, WmDecimalAmountDirective } from './decimal.directive';

import { WmLocalDateFormatterPipe, WmLocalDateTimeFormatterPipe } from '../services/local_date_format.pipe';
import { UserService } from '../services/';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    TranslateModule,
    NgxPaginationModule,
    MyDatePickerModule,
    ReactiveFormsModule,
  ],
  declarations: [
    WmPaginationComponent,
    WmLocalDateFormatterPipe,
    WmLocalDateTimeFormatterPipe,
    WmLocalDateTimeFormatterPipe,
    WmDecimalPercentDirective,
    WmDecimalAmountDirective,
  ],
  exports: [
    WmPaginationComponent,
    WmLocalDateFormatterPipe,
    WmLocalDateTimeFormatterPipe,
    WmLocalDateFormatterPipe,
    WmDecimalPercentDirective,
    WmDecimalAmountDirective,
    TranslateModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
  ],
  providers: [
    TranslateService,
    UserService,
  ],
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/module.ts